import { bl_fi_entity_credit_limit_hdr_RowClass } from '../../../dbschema/bl_fi_entity_credit_limit_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class CreditLimitContainerModel extends BaseContainerModel{
    bl_fi_entity_credit_limit_hdr: bl_fi_entity_credit_limit_hdr_RowClass=new bl_fi_entity_credit_limit_hdr_RowClass();
}